import { useCallback, useEffect, useRef, useState } from 'react'
import { TenantFormModel } from '../model'
import { usePageDataIsEdited } from '../../../hooks/usePageDataIsEdited'
import { useEditedFormData } from '../../../containers/SingleSheetV2/hooks/editedFormData'

export type OnChangeTenant = <K extends keyof TenantFormModel>(
  path: K,
  value: TenantFormModel[K]
) => void

// 更新のみの画面のため新規作成の初期値は持たない。取得が完了するまでの
// プレースホルダで、isInitialized が立つまで画面には出ない。
const EMPTY_FORM_MODEL: TenantFormModel = {
  uuid: '',
  alias: '',
  iconUrl: '',
  displayName: '',
  officialName: '',
  emailDomainWhitelist: '',
  skipEmailVerification: false,
  defaultTimezoneId: undefined,
  dailyWorkHours: undefined,
  monthlyWorkDays: undefined,
  financialYearEndMonth: undefined,
  restrictTaskActualWorkByProjectPeriod: false,
}

// テナント設定画面のフォーム状態管理。formModel の保持・各項目の onChange・
// 編集フラグ追跡のみを担い、取得/保存などのライフサイクルは data フックが持つ。
export const useTenantFormState = () => {
  const [formModel, setFormModel] = useState<TenantFormModel>(EMPTY_FORM_MODEL)
  // submit から最新の formModel を deps に入れずに参照するための ref。
  const formModelRef = useRef(formModel)
  useEffect(() => {
    formModelRef.current = formModel
  }, [formModel])
  const { edited, editedPageData, refreshedPageData } = usePageDataIsEdited()
  const { editedFormData, editFormData, refreshEditedFormData } =
    useEditedFormData()

  const onChangeTenant = useCallback<OnChangeTenant>(
    (path, value) => {
      setFormModel(prev => ({ ...prev, [path]: value }))
      editedPageData()
      editFormData(path)
    },
    [editedPageData, editFormData]
  )

  return {
    formModel,
    setFormModel,
    formModelRef,
    onChangeTenant,
    edited,
    refreshedPageData,
    editedFormData,
    refreshEditedFormData,
  }
}
